module.exports = __webpack_public_path__ + "media/application/images/company/founders/Alan-Faichney-53b87f6cb497119c0d7ce1e917571cb2.jpg";